import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
const Footer=()=> {
  const [cookieIsAccepted,setCookieIsAccepted]=useState(true)
  const [ageIsAccepted,setAgeIsAccepted]=useState(true)

  useEffect(()=>{
const value=localStorage.getItem("cookie")
const ageValue=localStorage.getItem("age")
if(value)
{
  setCookieIsAccepted(false)
}
if(ageValue)
  {
    setAgeIsAccepted(false)
  }
  },[])

const acceptCookie=()=>{
  setCookieIsAccepted(false)
  localStorage.setItem("cookie",true)
}
const acceptAge=()=>{
  setAgeIsAccepted(false)
  localStorage.setItem("age",true)
}

  return (
    <>
<footer>
    <div
        style={{
          fontSize: "12px",
          color: "#666",
          textAlign: "center",
          padding: "20px",
          backgroundColor: "#f9f9f9",
        }}
    >
<p>
    <strong>Vastuuvapauslauseke (Disclaimer):</strong>
    <br />
    Tämä verkkosivusto tarjoaa vain sosiaalisia kasinopelejä viihdetarkoituksiin. Pelit eivät sisällä mahdollisuutta käyttää oikeaa rahaa tai voittaa oikean rahan palkintoja.
    <br /><br />
    <strong>Ikäraja:</strong>
    <br />
    Tälle verkkosivustolle ja sen sisältöön pääsy on sallittua vain yli 18-vuotiaille henkilöille. Älä käytä tätä verkkosivustoa, jos et täytä ikävaatimusta.
    <br /><br />
    <strong>Riippuvuusvaroitus:</strong>
    <br />
    Muista, että pelejä tulisi pelata vain huvin vuoksi. Pelaa vastuullisesti ja pidä pelaamistottumuksesi hallinnassa. Apua peliriippuvuuteen saat 
    <a
        href="https://www.gamblingtherapy.org/"
        target="_blank"
        rel="noopener noreferrer"
        style={{ color: "#007BFF" }}
    >
        tältä sivustolta
    </a>.
    <br /><br />
    <strong>Lakien noudattaminen:</strong>
    <br />
    Tämä verkkosivusto toimii sovellettavien lakien ja säädösten mukaisesti. Käyttäjät ovat vastuussa oman alueensa lakien noudattamisesta.
</p>
</div>
<div className="top-row">
    <div className="container">
        <p className="footer-text text">
            Tämä verkkosivusto on omistettu tarjoamaan maksutonta viihdettä. Kaikki verkkosivustollamme tarjotut pelit on kehitetty sisäisesti ja tarkoitettu yksinomaan viihdetarkoituksiin. Ne on suunnattu yli 18-vuotiaille aikuisille. Sosiaaliset kasinopelimme eivät sisällä oikean rahan panoksia eivätkä tarjoa rahapalkintoja. Menestystä näissä peleissä ei tule tulkita viitteeksi menestyksestä oikean rahan rahapeleissä. Edistämme vastuullista pelaamista ja korostamme, että pelimme on tarkoitettu vain viihteeksi.
        </p>
    </div>
</div>
<div className="bottom-row mt-3 mb-3">
    <div className="container d-flex align-items-center justify-content-between">
        <div className="logo-wrapper d-flex align-items-center justify-content-between">
            <a href="/">
                <img src="/logo.png" alt="Crazy Monkey Slot Logo"/>
            </a>
            <a href="/" className="main-logo-text">
                <p className="game-name">
                    Crazy Monkey
                </p>
                <span>
                    Ilmainen Sosiaalinen Kasinosi
                </span>
            </a>
        </div>
        <div className="navigation">
            <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" aria-hidden="true" focusable="false"><rect x="4" y="7.5" width="16" height="1.5"></rect><rect x="4" y="15" width="16" height="1.5"></rect></svg>
            <ul className="nav-list d-flex align-items-center justify-content-center">
                <li>
                    <a href="/">
                        Etusivu
                    </a>
                </li>
                <li>
                    <a href="contact-us">
                        Ota yhteyttä
                    </a>
                </li>
                <li>
                    <a href="privacy-policy">
                        Tietosuojakäytäntö
                    </a>
                </li>
                <li>
                    <a href="terms-and-conditions">
                        Käyttöehdot
                    </a>
                </li>
            </ul>
        </div>
    </div>
</div>

</footer>

{
    cookieIsAccepted &&(
      <div className="cookie-banner" id="cookie-banner" style={{display:'flex'}}>
      <p>Käytämme evästeitä parantaaksemme verkkosivustomme suorituskykyä. Jatkamalla sivuston käyttöä hyväksyt evästeiden käytön.</p>
      <button  onClick={()=>acceptCookie()}  id="accept-cookies">Submit</button>
  </div>
    )
  }
  {
   ageIsAccepted && (
    <div className="age-check-popup" id="age-check-popup">
      <div className="popup-inner-wrapper">
          <h3 className="text-center">
              Ikävarmistus
          </h3>
          <p className="popup-text text-center">
              Sinun on oltava vähintään <span>18</span> vuotta vanha osallistuaksesi.
          </p>
          <button type="button" onClick={() => acceptAge()} className="text-center popup-btn">
              Kyllä
          </button>
      </div>
    </div>
  )
  
  }
    </>

  );
}

export default Footer;